import ar from './locale/ar.json';
import bg from './locale/bg.json';
import ca from './locale/ca.json';
import cs from './locale/cs.json';
import da from './locale/da.json';
import de from './locale/de.json';
import el from './locale/el.json';
import en from './locale/en.json';
import es from './locale/es.json';
import fi from './locale/fi.json';
import fr from './locale/fr.json';
import hu from './locale/hu.json';
import hr from './locale/hr.json';
import is from './locale/is.json';
import it from './locale/it.json';
import lt from './locale/lt.json';
import lv from './locale/lv.json';
import nl from './locale/nl.json';
import no from './locale/no.json';
import pl from './locale/pl.json';
import pt from './locale/pt.json';
import ro from './locale/ro.json';
import ru from './locale/ru.json';
import sk from './locale/sk.json';
import sl from './locale/sl.json';
import sq from './locale/sq.json';
import sr from './locale/sr.json';
import sv from './locale/sv.json';
import tr from './locale/tr.json';
import uk from './locale/uk.json';
import vi from './locale/vi.json';

export default {
  ar,
  bg,
  ca,
  cs,
  da,
  de,
  el,
  en,
  es,
  fi,
  fr,
  hu,
  hr,
  is,
  it,
  lt,
  lv,
  nl,
  no,
  pl,
  pt,
  ro,
  ru,
  sk,
  sl,
  sq,
  sr,
  sv,
  tr,
  uk,
  vi,
};
